<template>
  <div class="h-screen wrapper">
    <transition @after-enter="enter" @after-leave="afterLeave">
      <a
        :class="{ fadeOut: !showSplashScreen, fadeIn: showSplashScreen }"
        @click="toggleSplashScreen()"
        class="block h-full animated absolute w-full bg-black z-50"
        href="#"
        v-show="showSplashScreen"
      >
        <video
          autoplay
          class="h-screen absolute"
          loop
          muted
          playsinline
          style="top: -200px"
          v-if="showSplashScreen"
        >
          <source src="@/assets/videos/splash.mp4" type="video/mp4" />
        </video>
        <div class="text-center w-full absolute" style="bottom: 424px;">
          <img class="mx-auto" src="@/assets/images/tap-area.svg" />
          <img class="mx-auto -mt-3" src="@/assets/images/tap-hand.svg" />
          <div
            class="text-center mt-4 uppercase"
            style="font-size: 20px; font-weight: 300;"
          >
            tap screen
          </div>
        </div>
      </a>
    </transition>
    <div v-if="loadContent">
      <div class="flex justify-center animated bounceInDown fast" id="header">
        <img alt="Clariant logo" src="@/assets/images/clariant-logo.svg" />
      </div>
      <div id="content">
        <transition appear mode="out-in" name="slide-fade">
          <router-view />
        </transition>
      </div>
    </div>
    <div class="cover">
      <div style="line-height: 134px; text-align: center; font-size: 18px;">
        by <span style="font-weight: 900;">THE HUMANS</span>
      </div>
    </div>
  </div>
</template>

<style>
@import "~animate.css";
@import "assets/css/tailwind.css";
@import "assets/css/style.css";

/* Added to show in browsers */
.h-screen {
  height: 200vh;
}

.slide-fade-enter {
  transform: translateY(5rem);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.2s ease;
}

.slide-fade-leave-to {
  transform: translateY(-5rem);
  opacity: 0;
}

.cover {
  width: 1080px;
  height: 134px;
  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.8) 30%,
    rgba(0, 0, 0, 1)
  );
  position: absolute;
  bottom: 0;
  left: 0;
}
</style>
<script>
export default {
  data() {
    return {
      showSplashScreen: true,
      loadContent: false
    };
  },
  methods: {
    toggleSplashScreen() {
      this.showSplashScreen = !this.showSplashScreen;
    },
    enableSplashScreen() {
      this.showSplashScreen = true;
      this.loadContent = false;
      this.$router.push("/");
    },
    enter() {
      this.loadContent = false;
    },
    afterLeave() {
      this.loadContent = true;
    },
    resetTimer() {
      clearTimeout(window.time);
      window.time = setTimeout(this.enableSplashScreen, 5 * 60 * 1000);
    }
  },
  mounted() {
    window.onload = this.resetTimer;
    document.onmousemove = this.resetTimer;
    document.onkeypress = this.resetTimer;
    document.onclick = this.resetTimer;
  }
};
</script>
